import cloneDeep from 'lodash/cloneDeep'
import state from './state.js'
import actions from './actions.js'
import mutations from './mutations.js'

export default {
  state: cloneDeep(state),
  actions,
  mutations,
}
